import { queryCustomerArticleDiscounts } from "./queries/queryCustomerArticleDiscounts"
import { queryCustomerProductSelections } from "./queries/queryCustomerProductSelections"
import { typeSpecialConditions } from "./specialConditions"

const specialConditionsSchema = {
  types: [typeSpecialConditions],
  resolvers: {
    Query: { ...queryCustomerProductSelections, ...queryCustomerArticleDiscounts },
    Mutation: {},
  },
}

export default specialConditionsSchema
